import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import styles from './index.css';

/**
 * 定义 Logo 组件
 */
class SecondNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.secondNav}>
                <p>数据中心 &gt;&gt;</p>
                <ul>
                    {content.map((item, index) => (
                        <li key={index}>
                            <a href={item.url} rel={rel} target="_blank">
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(SecondNav);
